export enum UserStatus {
    ACTIVE,
    SUSPENDED
  }  